<template>
  <div
    name="remote-control-modal"
    v-aha-emit-action.view="{ source }"
    class="remote-control-content text-center flex flex-col justify-center gap-4"
    :class="`items-${align}`"
  >
    <div
      class="qr-code-wrapper flex flex-col justify-center gap-2"
      :class="`items-${align}`"
    >
      <div class="font-bold">
        {{ $i18nPresenter.t('Control your slides from any device') }}
      </div>
      <p class="text-xs">
        {{ $i18nPresenter.t('Scan QR or copy the link below.') }}
      </p>
      <QRCodeVue
        :qrCodeImageUrl="remoteLinkQrCode"
        :isLoading="isLoadingRemoteLink"
      />
    </div>
    <div
      class="remote-control-button-wrapper flex gap-2"
      :class="`justify-${align}`"
    >
      <aha-pop-confirm
        placement="bottomRight"
        :title="$i18nPresenter.t('Reset access link?')"
        :ok-text="$i18nPresenter.t('OK')"
        :cancel-text="$i18nPresenter.t('Cancel')"
        :message="$i18nPresenter.t('All devices using the link will be disconnected.')"
        @confirm="() => resetRemoteLink(presentationId)"
      >
        <aha-antd-button
          name="reset-remote-link"
          v-aha-emit-action
          icon-name="arrow-clock-wise-rtl"
          variant="secondary"
          :aha-source="source"
          :submitting="isLoadingRemoteLink"
        >
          {{ $i18nPresenter.t('Reset link') }}
        </aha-antd-button>
      </aha-pop-confirm>
      <aha-antd-button
        variant="primary"
        icon-name="link-icon"
        icon-view-box="0 0 18 14"
        name="copy-remote-link"
        :aha-source="source"
        v-aha-click="copyLink"
      >
        {{ $i18nPresenter.t('Copy link') }}
      </aha-antd-button>
      <aha-toggle-tip
        to="reset-remote-link"
        :text="$i18nPresenter.t('Generate a new link. All currently connected devices will lose access.')"
      >
      </aha-toggle-tip>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QRCodeVue from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton/QRCode.vue'
import Utils from '@/util'

export default {
  components: {
    QRCodeVue,
  },
  props: {
    presentationId: {
      type: Number,
      required: true,
    },
    source: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'center',
    },
  },
  computed: {
    ...mapGetters('remoteControlLink', ['remoteLink', 'remoteLinkQrCode', 'isLoadingRemoteLink']),
  },
  mounted() {
    if (!this.presentationId) return
    this.getRemoteLink(this.presentationId)
  },
  methods: {
    ...mapActions('remoteControlLink', ['getRemoteLink', 'resetRemoteLink']),
    copyLink() {
      navigator.clipboard.writeText(this.remoteLink)
      Utils.showToastSuccess(this.$i18nPresenter.t('Link copied!'))
    },
  },
}
</script>
